import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from './http-client';
import { CommonService } from './common-service';
import { BaseEntityService } from './baseentity-service';

@Injectable()
export class PosicionService extends BaseEntityService {
    private currentYear;

    constructor(httpClient: HttpClient) {
        super(httpClient);
        let tmpDate = new Date();
        this.currentYear = tmpDate.getFullYear();
    }

    saveNew(posicion) {
        return this.httpClient.post('/api/posicion', posicion)
            .map((response: Response) => {
                return response.json();
            });
    }

    responseItemToEntity(responseItem: any): any {
        let fecha = new Date(responseItem.Fecha);
        return {
            ID: responseItem.Id,
            Posicion: responseItem.Posicion,
            Fecha: fecha,
            Time: fecha.getTime(),
            Ent_Id: responseItem.Ent_ID
        };
    }

    apiRoute: string = '/api/posicion';

    get YearOptions() {
        let array = [];
        array.push(this.currentYear);
        for (let index = 1; index <= 10; index++) {
            array.push(this.currentYear + index);
        }
        return array;
    }

    get MonthOptions() {
        return [
            {
                Value: 0, Name: 'Enero', ShortName: 'ENE'
            },
            {
                Value: 1, Name: 'Febrero', ShortName: 'FEB'
            },
            {
                Value: 2, Name: 'Marzo', ShortName: 'MAR'
            },
            {
                Value: 3, Name: 'Abril', ShortName: 'ABR'
            },
            {
                Value: 4, Name: 'Mayo', ShortName: 'MAY'
            },
            {
                Value: 5, Name: 'Junio', ShortName: 'JUN'
            },
            {
                Value: 6, Name: 'Julio', ShortName: 'JUL'
            },
            {
                Value: 7, Name: 'Agosto', ShortName: 'AGO'
            },
            {
                Value: 8, Name: 'Septiembre', ShortName: 'SEP'
            },
            {
                Value: 9, Name: 'Octubre', ShortName: 'OCT'
            },
            {
                Value: 10, Name: 'Noviembre', ShortName: 'NOV'
            },
            {
                Value: 11, Name: 'Diciembre', ShortName: 'DIC'
            }
        ];
    }

    sortItems(a, b) {
        return a.Time - b.Time;
    }

    getHiddenRows() {
      return this.httpClient.get('/api/posicion/oculta')
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    updateRows(rows) {
      return this.httpClient.put('/api/posicion/oculta', rows)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/posicion-service.ts